export function setAscPageContext() {
  if (typeof window === "undefined" || !window.asc_datalayer) return;

  const pageType = document.querySelector('data[id="page"]')?.value || "unknown";

  window.asc_datalayer.page_type = pageType.toLowerCase();

  switch (pageType) {
    case 'Search Results Page':
  }
}


export function initAscDataLayer(cfg) {
  if (typeof window === "undefined" || window.__ascInit) return;
  if (!cfg.measurementIds?.length) {
    console.warn("[ASC] init skipped — no measurement IDs in config", cfg);
    return;
  }

  const ids = cfg.measurementIds;
  console.log("[ASC] init with IDs:", ids);

  window.asc_datalayer = {
    currency: "usd", language: "en",
    website_industry: "automotive", user_type: "online_customer",
    measurement_ids: ids,
    store_name: (cfg.storeName || "").toLowerCase(),
    oem_brand:  (cfg.oemBrand  || "unknown").toLowerCase(),
    page_type: "unknown", items: [],
    events: [],
  };

  
  const gtagPresent = typeof window.gtag === "function";
  if (!gtagPresent) {
    console.warn("[ASC] window.gtag not found — using dataLayer shim. " + "Events will queue but won't send until gtag.js loads. " + "(Expected on local dev if GA/gtag isn't included.)");
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  ids.forEach(id => {
    window.gtag("config", id, { send_page_view: false });
    console.log("[ASC] configured", id);
  });

  const arr = window.asc_datalayer.events;
  const nativePush = arr.push.bind(arr);
  arr.push = (entry) => {
    const r = nativePush(entry);
    try {
      let name, params;
      if (typeof entry === "string") {
        name = entry; params = {};
      } else if (entry && typeof entry === "object") {
        ({ event: name, ...params } = entry);
      }
      if (!name) {
        console.warn("[ASC] pushed entry has no event name, not firing:", entry);
        return r;
      }
      console.log("[ASC] firing", name, "→", ids, params);
      window.gtag("event", name, { send_to: ids, ...params });
    } catch (e) {
      console.error("[ASC] failed to fire event:", e, entry);
    }
    return r;
  };

  window.__ascInit = true;
  console.log("[ASC] init complete, watcher attached");
}


export function setAscItems(vehicles) {
  if (typeof window === "undefined" || !window.asc_datalayer) return;
  window.asc_datalayer.items = vehicles.map(v => ({
    item_id: v.VehicleInfo.VIN,
    item_number: v.VehicleInfo.StockNumber,
    item_price: String(v.Pricing.ExtraPrice1 || v.Pricing.List || ""),
    item_condition: v.VehicleInfo.IsCertified ? "certified" : (v.VehicleInfo.IsNew ? "new" : "used"),
    item_year: String(v.VehicleInfo.Year),
    item_make: v.VehicleInfo.Make,
    item_model: v.VehicleInfo.Model,
    item_variant: v.VehicleInfo.Trim,
    item_color: v.VehicleInfo.GenericExteriorColor,
    item_type: v.VehicleInfo.BodyStyle,
    item_category: "automotive",
    item_fuel_type: v.VehicleInfo.EngineFuelType,
    item_inventory_date: v.VehicleInfo.InStockDate,
    item_mileage: String(v.VehicleInfo.Mileage),
  }));
}